<template>
  <div id="signedDataEcharts">
    <div class="center-DataBox">
        <div class="left-DataBox">
            <div id="lOne-box" >
                <div class="BoxText">项目地区</div>
                <div class="regionData">
                    <div class="BoxData" v-for="(item,index) in ProjectAreaList.reportList" :key="index">
                        <div class="SmBoxData">
                        <div class="region">{{item.itemName}}</div>
                        <div class="number">{{AmountFormat(item.amount)}}<i>元</i></div>   
                        <div class="regionB">{{item.count}}<i>个</i></div>                 
                        </div>
                        <div class="DataImg" v-show="screenWidth <=1366 ? false : true">
                            <img :src="item.itemIcon" alt="">
                        </div>
                    </div>
                </div> 
            </div>
            <div id="progress-bar" ref="progressBar"></div>
        </div>
        <div class="right-DataBox">
            <div class="pieOneBox">
                <div id="echartsBox" ref="pieOne"></div>
                <div class="nodata_box" v-if="Judge">
                    <img src="https://xmyun.zhoty.com/xmerp/pcadmin/static/images/report_item_nodata.png" />
                    <span>暂无数据</span>
                </div>
            </div>
            <div class="pieTwoBox">
                <div id="echarts-Box" ref="pieTwo"></div>
                <div class="nodata_box" v-if="CooperationTypeJudge">
                    <img src="https://xmyun.zhoty.com/xmerp/pcadmin/static/images/report_item_nodata.png" />
                    <span>暂无数据</span>
                </div>
            </div>
            <div id="echarts" ref="pieThree"></div>
        </div>
    </div>
    <div class="bottom-DataBox">
            <div class="dataSortBox">
                <div class="top-Name">
                    <i class="el-icon-s-data"></i>
                    <p class="titleName">项目签约金额排行</p>
                </div>
                <div id="dataSort" v-if="RankingProjectAmountList.length">
                    <div class="bottom-Data">
                        <table class="table-Box" style="table-layout:fixed">
                            <tr class="herader-Box">
                                <td :width="screenWidth <= 1366 ? 200 : (screenWidth <= 1536 ? 380 : 530)" :class="{'tdName' : screenWidth == 1920}">项目名称</td>
                                <td :width="screenWidth >= 1536 ? 140 : 120" align="right" class="tdMoney">签约金额(元)</td>
                            </tr>
                            <tr :height="screenWidth <= 768 ? 30 : (screenWidth <= 1366 ? 42 : 42)" v-for="(item,index) in RankingProjectAmountList" :key="index">
                                <td>
                                    <div :class="{'smallBox' :screenWidth == 1920,'TdWidth' :screenWidth == 1536,'dataBox' :screenWidth == 1366,}" style="display: flex">
                                        <span class="showTips" v-if="TextShow && actived==index" :style="{left: x + 'px'}">{{item.name}}</span>
                                        <span style="margin-right:10px;" :class="{'red' :item.serialNumber=='1','orange' :item.serialNumber=='2','yellow' :item.serialNumber=='3'}" >{{item.serialNumber}}</span>
                                        <span  @mouseover.stop="getText($event,item.name);actived=index" @mouseout.stop="TextShow = false" class="pro_name">
                                        {{item.name}}
                                        </span>
                                        </div>
                                </td>
                                <td align="right">{{AmountFormat(item.amount)}}</td>
                            </tr>   
                        </table>
                    </div>                
                </div>
                <div class="nodata_box" v-else>
                    <img src="https://xmyun.zhoty.com/xmerp/pcadmin/static/images/report_item_nodata.png" />
                    <span>暂无数据</span>
                </div>
            </div>
            <div class="S-dataSortBox">
                <div class="top-Name">
                    <i class="el-icon-s-data"></i>
                    <p class="titleName">项目总监签约排行</p>
                </div>
                <ul class="tablist">
                  <li :class="{'active': activeProjectName === 'AMOUNT'}" @click="handleClick('AMOUNT')">签约金额</li>
                  <li :class="{'active': activeProjectName === 'QUANTITY'}" @click="handleClick('QUANTITY')">签约数量</li>
                </ul>
                <div id="S-dataSort" v-if="DirectorRankingList.length && activeProjectName === 'AMOUNT'">
                    <div class="bottom-Data">
                        <table class="table-Box">
                            <tr class="herader-Box">
                                <td :width="screenWidth <= 1366 ? 200 : 300" >项目总监</td>
                                <td :class="{'show' :screenWidth <= 768}" width="150" align="center">签约总数(个)</td>
                                <td width="140" align="right">签约金额(元)</td>
                            </tr>
                            <tr :height="screenWidth <= 768 ? 30 : (screenWidth <= 1366 ? 38 : 38)" v-for="(item,index) in DirectorRankingList" :key="index">
                                <td>
                                    <div class="dataBox">
                                        <span style="margin-right:10px;" :class="{'red' :item.serialNumber=='1','orange' :item.serialNumber=='2','yellow' :item.serialNumber=='3'}">{{item.serialNumber}}</span>{{item.pmName}}&nbsp;{{item.phone}}
                                    </div>
                                </td>
                                <td :class="{'show' :screenWidth <= 768}" align="center">{{item.count}}</td>
                                <td align="right">{{AmountFormat(item.amount)}}</td>
                            </tr>                                  
                        </table>
                    </div>                            
                </div>
                <div id="S-dataSort" v-else-if="DirectorRankingList.length && activeProjectName === 'QUANTITY'">
                    <div class="bottom-Data" >
                        <table class="table-Box">
                            <tr class="herader-Box">
                                <td :width="screenWidth <= 1366 ? 200 : 500" >项目总监</td>
                                <td width="100" align="center">签约总数(个)</td>
                            </tr>
                            <tr :height="screenWidth <= 768 ? 30 : (screenWidth <= 1366 ? 38 : 38)" v-for="(item,index) in DirectorRankingList" :key="index">
                                <td>
                                    <div class="dataBox">
                                        <span style="margin-right:10px;" :class="{'red' :item.serialNumber=='1','orange' :item.serialNumber=='2','yellow' :item.serialNumber=='3'}">{{item.serialNumber}}</span>{{item.pmName}}&nbsp;{{item.phone}}
                                    </div>
                                </td>
                                <td align="center">{{item.count}}</td>
                            </tr>                                  
                        </table>
                    </div>          
                </div>
                <div class="nodata_box" v-else>
                    <img src="https://xmyun.zhoty.com/xmerp/pcadmin/static/images/report_item_nodata.png" />
                    <span>暂无数据</span>
                </div>
            </div>
    </div>
  </div>
</template>

<script>
import {amountFormat,EchartsformatDate} from '@/helper/VueHelper.js'
export default {
  props:['ProjectTypeList','PieprojectTypeList','CooperationTypeList','ProjectLevelList','RankingProjectAmountList','DirectorRankingList','ProjectAreaList','screenWidth'],
  data() {
    return {
        progressLsit: [] , // 背景
        Judge:'',
        CooperationTypeJudge:'',
        CopperationArr:[],
        PieprojectArr:[],
        x:0,
        y:0,
        ClickText:'',
        TextShow:false,
        actived:0,
        activeProjectName: 'AMOUNT'
    };
  },
  methods:{
    handleClick(type) {
      if(type !== this.activeProjectName){
        this.activeProjectName = type
        this.$emit('getDirectorRanking', this.activeProjectName)
      }
    },
    AmountFormat(val){
        return amountFormat(val)
    },
    // 工程类型
    initChart2(){
        let {series,yAxis} = this.ProjectTypeList
        let chart2 = this.$echarts.getInstanceByDom(this.$refs.progressBar);
        if (chart2 == null) {
            this.myChart2 = this.$echarts.init(this.$refs.progressBar);
        }
        let option = {
                textStyle: {
                fontFamily: 'PingFang-M'
                },
                title: {
                    text: '工程类型',
                    top:'24',  
                    left:this.$route.query.identification ? '20' : '30',
                    textStyle:{
                      fontWeight:500,
                    }                    
                },
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                    type: 'shadow'
                    },
                formatter: function (params) {
                    const str = `
                                <div style="margin:3px 10px;">金额：${amountFormat(series[0].money[params[0].dataIndex])}元</div>
                                <div style="margin:3px 10px;">占比：${params[0].value}%</div>
                                <div style="margin:3px 10px;">个数：${series[0].data[params[0].dataIndex]}个</div>
                                `
                    return str
                    }  
                },
                grid: {
                    left:this.$route.query.identification  ? '2' : '3%',
                    right: this.$route.query.identification  ? '10%' : '4%',
                    bottom: '3%',
                    containLabel: true
                },
                xAxis: [
                    {
                    position: 'top',  
                    type: 'value',
                    min:0,
                    max:this.$route.query.identification ? Math.ceil(Math.max(...series[0].percent) / 10)*10 : 100,
                    splitNumber:this.$route.query.identification  ? 5 : 10,
                    // max:100,
                    // splitNumber:10,
                    boundaryGap: [0, 0.01],
                    splitLine: {
                    show: true,
                    lineStyle: {
                        color: '#DDDDDD',
                        type:'dashed'
                    },
                    }, 
                    axisTick:false, // 刻度
                    axisLine:{
                        show:false // 轴  
                    },
                    axisLabel: {
                    interval:1,
                    formatter:'{value}%',
                    // padding:[0,10,0,0]
                    },                 
                }
                ],
                yAxis: [
                    {
                    type: 'category',
                    inverse:true,
                    axisLabel: {
                        formatter: (val,index)=>{
                        let res =  '';
                        series[0].data.forEach((item,i)=>{
                            if( i == index) {
                            res = item
                            }
                        })
                        return val + `(${res}个)`
                        }
                    },                  
                    data: yAxis.data,
                    splitLine: {
                        show: false,
                        lineStyle: {
                        color: '#DDDDDD',
                        type:'dashed'
                        },
                    },
                    axisTick:false, // 刻度
                    axisLine:{
                        show:false // 轴 
                    },
                    axisPointer: {
                      type: 'none'
                    }                                          
                    }           
                ],
                series: [
                    {
                    type: 'bar',
                    data: series[0].percent,
                    barWidth : 20,
                    itemStyle:{
                        normal:{
                        color:'#57b9ff',
                        label:{
                            show:true,
                            position:["0%", "25%"],
                            textStyle:{
                            color:'#666666'
                            },
                            formatter:(value)=>{
                            return `${value.value} % （${amountFormat(series[0].money[value.dataIndex])}元） `
                            }
                        }
                        } 
                    },
                    },
                    {
                        type: 'bar',
                        barWidth: 20,
                        silent: true,
                        zlevel: -1,
                        barGap: '-100%',
                        data: this.progressLsit,
                        itemStyle: {
                            normal: {
                                color: '#eeeeee',
                            }
                        },
                    },                    
                ]
                };
    this.myChart2.setOption(option);
    window.addEventListener("resize", () => {
        if(this.$route.query.identification) {
        var resize = {
            width: this.screenWidth - 21,
        };
        this.myChart2.resize(resize)
        } else {
        this.myChart2.resize()
        }
    })       
    },    
    // 项目类型
    initChart3(){
    let PieprojectArrList = this.PieprojectTypeList
    let JudgeConditions = this.$route.query.identification
    let Chart3 = this.$echarts.getInstanceByDom(this.$refs.pieOne);
    if (Chart3 == null) {
        this.myChart3 = this.$echarts.init(this.$refs.pieOne);
    }          
    const option = {
    textStyle: {
        fontFamily: 'PingFang-M'
    },
    title: {
        text: "项目类型",
        top:'24',  
        left:this.$route.query.identification ? '20' : '30',
        textStyle:{
            fontWeight:500,
        }
    },
    tooltip: {
    show:JudgeConditions ? true : (this.screenWidth <=1366 ? true : this.screenWidth == 1536 ? true : false) , 
    trigger: 'item',    
    formatter:params=>{
    return `<div style="font-size:10px;">
                <div>${params.data.name}：${amountFormat(PieprojectArrList[params.dataIndex].money)}元</div>
                <div>占比：${params.data.value}%</div>
                <div>数量：${PieprojectArrList[params.dataIndex].value}个</div>
            </div>`
    }
    },
    color: ["#59b9fe", "#62d8ae", "#ffb971"],
    legend: {
        orient:this.$route.query.identification ? "horizontal" : "vertical",
        x:this.$route.query.identification ? '120': "35",
        y:this.$route.query.identification ? "24" : '70',
        itemGap:this.$route.query.identification ? 30 : 14,
        itemWidth: 10,
        itemHeight: 11,
        data: this.PieprojectTypeList,
        formatter: (name) => {
        return `{a|${name}}`
        },
        textStyle: {
            fontSize: '13',            
            height: 10,
                rich: {
                a: {
                lineHeight: 14,
            },
            }
        },         
    },
    series: [
        {
        name: "项目类型",
        type: "pie",
        stillShowZeroSum:false,
        radius:JudgeConditions ? ['45%','70%'] : (this.screenWidth <= 1366 ? ['40%', '60%'] : this.screenWidth == 1536 ? ['40%', '60%'] : ['45%', '60%']),
        center: JudgeConditions ? ['50%','58%'] :(this.screenWidth <= 1366 ? ['55%', '55%'] :  this.screenWidth == 1536 ? ['55%', '55%'] : ['55%', '57%']) ,
        silent:this.$route.query.identification ? false : (this.screenWidth <= 1366 ? false : this.screenWidth == 1536 ?  false :true) , // 鼠标悬浮高亮
        itemStyle: {
            align: "left",
            normal: {
            // borderWidthLeft:1,
            borderWidthLeft:this.$route.query.identification ? 'none' : (this.screenWidth <=1366 ? 'none' : this.screenWidth == 1536 ? 'none' : 1) ,
            borderColor:this.$route.query.identification ? 'none' : (this.screenWidth <=1366 ? 'none' : this.screenWidth == 1536 ? 'none' : '#fff') ,
            // borderColor:'#fff',
            label: {
                position:this.$route.query.identification ? 'inside' : (this.screenWidth <=1366 ? 'inside' : this.screenWidth == 1536 ? 'inside' : 'outside') ,
                show:this.Judge  ? false : true,
                align: "left",
                padding:JudgeConditions ? [0,0,0,0] :  (this.screenWidth <=1366 ? [0,0,0,0] : this.screenWidth == 1536 ? [0,0,0,0] : [25, 0, 0, 0]),
                color: "#fff",
                fontSize:this.$route.query.identification ? 15 : 12,
                formatter: (params) => {
                    if(JudgeConditions == 'pplet' || this.screenWidth <=1366 || this.screenWidth ==1536 ){
                        return params.data.value == 0 ? '' : `${params.data.value}%`
                    }else{
                        return `{left|\n${params.data.name}：${amountFormat(PieprojectArrList[params.dataIndex].money)}元\n占比：${params.data.value}%\n数量：${PieprojectArrList[params.dataIndex].value}个\n}`;
                    }
                },
                rich: {
                left: {
                    align: "left",
                    lineHeight: this.$route.query.identification ? 5 : (this.screenWidth <= 1366 ? 10 : this.screenWidth == 1536 ? 10 : 20),
                    color: "#666666",
                },
                },
            },
            },
        },
        labelLine: {
            normal: {
            show:this.Judge ? false : true,
            length: 20,
            length2: 25,
            },
        },
        data: this.PieprojectArr,
        },
    ],
    };
    this.myChart3.setOption(option);
    window.addEventListener("resize", () => {
        if(this.$route.query.identification) {
        var resize = {
            width: this.screenWidth - 21,
        };
        this.myChart3.resize(resize)
        } else {
        this.myChart3.resize()
        }
    })  
    },
    // 合作类型
    initChart4(){
    const CopperationArrList = this.CooperationTypeList
    let Chart4 = this.$echarts.getInstanceByDom(this.$refs.pieTwo);
    if (Chart4 == null) {
        this.myChart4 = this.$echarts.init(this.$refs.pieTwo);
    }          
    const option = {
    textStyle: {
        fontFamily: 'PingFang-M'
    },
    title: {
        text: "合作类型",
        top:'24',  
        left:this.$route.query.identification ? '20' : '30',
        textStyle:{
            fontWeight:500,
        }
    },
    tooltip: {
    show:this.$route.query.identification ? true : (this.screenWidth <=1366 ? true : this.screenWidth == 1536 ? true : false) , 
    trigger: 'item',  
    formatter:params=>{
    return `<div style="font-size:12px; padding:2px;">
                <div>${params.data.name}：${amountFormat(CopperationArrList[params.dataIndex].money)}元</div>
                <div>占比：${params.data.value}%</div>
                <div>数量：${CopperationArrList[params.dataIndex].value}个</div>
            </div>`
    }
    },
    color: ["#59b9fe", "#62d8ae", "#ffb971"],
    legend: {
        orient:this.$route.query.identification ? "horizontal" : "vertical",
        x:this.$route.query.identification ? '120': "35",
        y:this.$route.query.identification ? "24" : '70',
        itemGap:this.$route.query.identification ? 30 :14,
        itemWidth: 10,
        itemHeight: 11,
        data: this.CooperationTypeList,
        formatter: (name) => {
            return `{a|${name}}`
        },
        textStyle: {
            fontSize: '13',            
            height: 10,
                rich: {
                a: {
                lineHeight: 14,
            },
            }
        },         
    },
    series: [
        {
        name: "项目类型",
        type: "pie",
        stillShowZeroSum:false,
        radius:this.$route.query.identification ? ['45%','70%'] : (this.screenWidth <= 1366 ? ['0%','60%']:['0%','60%']),
        center:  this.$route.query.identification ? ['50%','58%'] :(this.screenWidth <= 1366 ? ['55%', '55%'] : ['50%', '55%']) ,
        silent: this.$route.query.identification ? false : (this.screenWidth <= 1366 ? false : this.screenWidth == 1536 ?  false :true) , // 鼠标悬浮高亮
        itemStyle: {
            align: "left",
            normal: {
            borderWidthLeft:this.$route.query.identification ? 'none' : (this.screenWidth <=1366 ? 'none' : this.screenWidth == 1536 ? 'none' : 1) ,
            borderColor:this.$route.query.identification ? 'none' : (this.screenWidth <=1366 ? 'none' : this.screenWidth == 1536 ? 'none' : '#fff') ,
            label: {
                show:this.CooperationTypeJudge ? false : true,
                align: "left",
                position:this.$route.query.identification ? 'inside' : (this.screenWidth <=1366 ? 'inside' : this.screenWidth == 1536 ? 'inside' : 'outside') ,
                padding:this.$route.query.identification ? [0,0,0,0] :  (this.screenWidth <=1366 ? [0,0,0,0] : this.screenWidth == 1536 ? [0,0,0,0] : [25, 0, 0, 0]),
                color: "#fff",
                formatter: (params) => {
                if(this.$route.query.identification == 'pplet' || this.screenWidth <=1366 || this.screenWidth == 1536){
                    return params.data.value == 0 ? '' : `${params.data.value}%`
                }else{
                    return `{left|\n${params.data.name}：${amountFormat(CopperationArrList[params.dataIndex].money)}元\n占比：${params.data.value}%\n数量：${CopperationArrList[params.dataIndex].value}个\n}`;
                }
                },
                rich: {
                left: {
                    align: "left",
                    lineHeight: 15,
                    color: "#666666",
                },
                },
            },
            },
        },
        labelLine: {
            normal: {
            show:this.CooperationTypeJudge ? false : true,
            length: 15,
            length2: 20,
            },
        },
        data: this.CopperationArr,
        },
    ],
    };
    this.myChart4.setOption(option);
    window.addEventListener("resize", () => {
        if(this.$route.query.identification) {
        var resize = {
            width: this.screenWidth - 21,
        };
        this.myChart4.resize(resize)
        } else {
        this.myChart4.resize()
        }
    }) 
    }, 
    // 项目等级
    initChart5(){
        let { legend,series,xAxis} = this.ProjectLevelList
        let maxPercent = Math.ceil(Math.max(...series[0].percent) / 10) * 10;
        let maxAmount = Math.ceil(Math.max(...series[1].data) / 10) * 10;
        // console.log(maxAmount)
        let chart5 = this.$echarts.getInstanceByDom(this.$refs.pieThree);
        if (chart5 == null) {
            this.myChart5 = this.$echarts.init(this.$refs.pieThree);
        }
        const option = {
                    textStyle: {
                        fontFamily: 'PingFang-M'
                    },
                    title: {
                    text: '项目等级',
                    top:'24',  
                    left:this.$route.query.identification ? '20' : '30',
                    textStyle:{
                        fontWeight:500,
                    }
                    },
                    grid: {
                    left:this.$route.query.identification ? '36' :  '46px',
                    right: this.$route.query.identification ? '10%' : '3%',
                    bottom: '5%',
                    top:this.$route.query.identification ? '30%' : '28%',
                    containLabel: true
                    },
                    opacity:0.1,       
                    tooltip: {
                    trigger: 'axis',
                    formatter:function(params){
                        // console.log(params)
                        // const str = `
                        //             <div style="margin:3px 10px;">${params[0].axisValue}：${params[1].data}人</div>
                        //             <div style="margin:3px 10px;">占比：${params[0].data}%</div>
                        // `
                        let h = `<div>`;
                        params.reverse().forEach((item,index) => {
                            if (item.seriesIndex == 1) {
                                h += `<div style="margin:3px 10px;">${item.axisValue}：${amountFormat(item.data)}元</div>
                                    <div style="margin:3px 10px;">个数：${series[1].value[series[1].data.findIndex(e => e == item.data)]}个</div>`;
                            } else {
                                h += `<div style="margin:3px 10px;">占比：${item.data}%</div>
                                        </div>`
                            }
                        // h += `<div style="margin:3px 10px;">个数：${series[1].value[index]}个</div>`
                        });              

                        return h
                    }
                    },
                    legend: {
                    data: legend,
                    itemWidth: 40,// 单个icon的width（单位px）
                    itemHeight: 8,// 单个icon的height（单位px）
                    itemGap: 20,// 每个icon之间的距离（单位px）
                    top:'24',
                    left:this.$route.query.identification ? '110' : '180',
                    },
                    xAxis: [
                    {
                        type: 'category',
                        offset:5,
                        data: xAxis.data,
                        axisPointer: {
                        type: 'shadow'
                        },
      
                        // 分隔线
                        splitLine: {
                        show: Math.max(...series[0].percent,...series[1].data) == 0 ? false : true,
                        lineStyle: {
                            color: '#DDDDDD'
                        },
                        },
                        axisTick:{
                        show:false,
                        },  
                        axisLine:{
                        show:true,
                        lineStyle:{
                            color:'#DDDDDD'
                        }
                        },
                        axisPointer: {
                        type: 'none'
                        },
                        axisLabel: {
                            textStyle:{
                                color:'#666666'
                            }
                        }                                     
                    }
                    ],
                    yAxis: [
                    {
                        // 数据显示
                        offset:5,
                        type: 'value',
                        show:Math.max(...series[0].percent) == 0 ? false : true,
                        name: '百分比',
                        min: 0,
                        max: maxPercent,
                        interval: 10,
                        axisLabel: {
                        formatter: '{value}%',
                        textStyle:{
                            color:'#666666'
                        }
                        },
                        // 分隔线
                        splitLine: {
                        show: true,
                        lineStyle: {
                            color: '#DDDDDD'
                        },
                        },
                        // 坐标轴名称的文字样式
                        nameTextStyle: {
                            align:'left',
                            padding: [0,48,-5,0],
                            color:'#666666'
                        },
                        axisTick:false, // 刻度
                        axisLine:{
                        show:false // 轴  
                    }              
                    },
                    {
                        type: 'value',
                        name: '金额（万）',
                        show:Math.max(...series[1].data) == 0 ? false : true,
                        min: 0,
                        max: maxAmount,
                        interval: maxAmount == 0 ? 1 : maxAmount / (maxPercent / 10),
                        axisLabel: {
                        formatter: function(value) {
                            return Math.max(...series[0].percent, ...series[1].data) == 0 ? value : Math.ceil((value / 10000));
                        },
                        textStyle:{
                            color:'#666666'
                        }
                        },
                        splitLine: {
                        show: true,
                        lineStyle: {
                            color: '#DDDDDD'
                        },
                        },
                        // 坐标轴名称的文字样式 
                        nameTextStyle: {
                        padding: [0,0,-5,35],
                        color:'#666666'
                        },
                        axisTick:false, // 刻度
                        axisLine:{
                        show:false // 轴  
                        },                    
                    }
                    ],
                    series: [
                    {
                        name: series[0].name,
                        type: 'bar',
                        barWidth : this.$route.query.identification ? 30 : '60%',
                        data: series[0].percent,
                        itemStyle:{
                        normal:{
                        color:'rgba(87,185,255,0.35)',
                        // opacity:Math.max(...series[0].percent) == 0 ? 0 : 0.35,
                        borderColor:Math.max(...series[0].percent) == 0 ? 'rgba(87,185,255,0)' : 'rgba(87,185,255,1)'
                        }  
                        },
                        yAxisIndex: 0,
                    },
                    {
                        name: series[1].name,
                        type: 'line',
                        symbol:'rect',
                        symbolSize: 9,
                        hoverAnimation: false,
                        data: series[1].data,
                        itemStyle:{
                        normal:{
                            color:'#72d8c0',
                            opacity: series[1].data.reduce((a,b)=>a+b)===0 ? 0 : 1
                        } ,
                        emphasis: {          //突出效果配置(鼠标置于拐点上时)
                        borderWidth: 3,
                        borderColor: '#61d9ac',
                        color: '#61d9ac',
                        }, 
                        },
                        lineStyle:{
                            normal:{
                                opacity: series[1].data.reduce((a,b)=>a+b)===0 ? 0 : 1
                            }
                        },
                        yAxisIndex: 1,
                    },
                    ]
                };
        this.myChart5.setOption(option); 
        window.addEventListener("resize", () => {
            if(this.$route.query.identification) {
            var resize = {
                width: this.screenWidth - 21,
            };
            this.myChart5.resize(resize)
            } else {
            this.myChart5.resize()
            }
        })         
    },             
    getText(e,val){
        let identification = this.$route.query.identification
        this.x = e.layerX+40
        this.TextShow = true
        // if(val.length > 13 && this.screenWidth <= 1366){
        //     // this.ClickText = val
        //     this.x=identification?e.layerX+20:e.layerX+40
        //     this.TextShow = true
        // }else{
        //     this.TextShow = false
        // }
    }     
  },
  watch:{
    // 工程类型
    ProjectTypeList(val){
            this.progressLsit = []
         for(let i = 0;i < val.series[0].data.length;i++){
            if(this.$route.query.identification){
                let n = Math.ceil(Math.max(...val.series[0].percent) / 10)*10
                this.progressLsit.push(n)
            }else{
                this.progressLsit.push(100)
            }
            // this.progressLsit.push(100)
         }  
        this.$nextTick(function () {
        var myEvent = new Event('resize'); // 创建一个支持冒泡且不能被取消的resize事件
        window.dispatchEvent(myEvent); // 事件可以在任何元素触发
        })    
        this.initChart2()
    },
    // 项目类型
    PieprojectTypeList(val){
        this.PieprojectArr = []
        val.forEach(item=>{
            this.PieprojectArr.push({
                value:item.percent,
                name:item.name
            })
        })
        const res = val.every(item=>{
        if(item.value==0) return true
        else false
        })
        this.Judge = res
        this.$nextTick(function () {
        var myEvent = new Event('resize'); // 创建一个支持冒泡且不能被取消的resize事件
        window.dispatchEvent(myEvent); // 事件可以在任何元素触发
        }) 
        this.initChart3()
    },
    // 合作类型
    CooperationTypeList(val){
        this.CopperationArr = []
        val.forEach(item=>{
            this.CopperationArr.push({
                value:item.percent,
                name:item.name
            })
        })
        const res = val.every(item=>{
        if(item.value==0) return true
        else false
        })
        this.CooperationTypeJudge = res
        this.$nextTick(function () {
        var myEvent = new Event('resize'); // 创建一个支持冒泡且不能被取消的resize事件
        window.dispatchEvent(myEvent); // 事件可以在任何元素触发
        }) 
        this.initChart4()
    },
    // 项目等级
    ProjectLevelList(val){
        this.$nextTick(function () {
        var myEvent = new Event('resize'); // 创建一个支持冒泡且不能被取消的resize事件
        window.dispatchEvent(myEvent); // 事件可以在任何元素触发
        }) 
        this.initChart5()
    },
    // 项目金额排行
    RankingProjectAmountList(val){
        // console.log(val)
    },
    // 项目总监排行
    DirectorRankingList(val){
        // console.log(val)
    },
    // 项目地区
    ProjectAreaList(val){
        // console.log(val)
    },
    // 侦听器
    screenWidth(val){
    //   this.initChart3()
    //   this.initChart4()
    console.log(val)
    }
  }

}
</script>

<style lang="scss" scoped>
*{
    margin: 0;
    padding: 0;
}
#signedDataEcharts{
    .showTips {
        display: inline-block;
        position: absolute;
        left: 0;
        top: 10;
        padding: 6px 12px;
        background: rgba(0, 0, 0, 0.4);
        color: #fff;
        border-radius: 4px;
    }  
    .pro_name{
        display: inline-block;
        width: 90%;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    .smallBox{
        width: 6.6rem !important;
        text-overflow: ellipsis !important;
        white-space: nowrap !important;
        overflow: hidden !important;
        .showTips {
            display: inline-block;
            position: absolute;
            left: 0;
            top: 10;
            padding: 6px 12px;
            background: rgba(0, 0, 0, 0.4);
            color: #fff;
            border-radius: 4px;
        }  
    }
    .TdWidth{
        width: 2.6rem !important;
        text-overflow: ellipsis !important;
        white-space: nowrap !important;
        overflow: hidden !important;
        .showTips {
            display: inline-block;
            position: absolute;
            left: 0;
            top: 10;
            padding: 6px 12px;
            background: rgba(0, 0, 0, 0.4);
            color: #fff;
            border-radius: 4px;
        }
    }
    .tdName{
        width: 5rem !important;
    }
    .center-DataBox{
        display: flex;
        justify-content: space-between;
        margin-top: 0.24rem;
        .left-DataBox{
            width: calc(60% - 0.12rem);
            #lOne-box,#progress-bar,.dataSortBox{
                width: 100%;
                height: 1.84rem;
                background-color: #fff;
                -webkit-box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
                box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
                border-radius: 0.1rem;                                           
            }
            #lOne-box{
                .BoxText{
                    font-size: 0.18rem;
                    padding-top: 0.24rem;
                    padding-left: 0.2rem;
                }
                .regionData{
                display: flex;
                .BoxData{
                    display: flex;
                    height: 1rem;
                    width: 30%;
                    margin-left: 0.2rem;
                    justify-content: space-between;
                    padding-right: 0.16rem;
                    border-right: 1px solid #f3f3f3;
                    .SmBoxData{
                    .region{
                        font-size: 0.08rem;
                        color:#666666;
                        margin-top: 0.2rem;
                    } 
                    .regionB{
                        font-size: 0.08rem;
                        color:#666666;
                        margin-top: 0.1rem;
                        i{
                            font-style: normal;
                        }
                    }                  
                    .number{
                        // line-height: .78rem;
                        // margin-right: 0.32rem;
                        font-size: 0.18rem;
                        margin-top: 0.1rem;
                        i{
                            font-style: normal;
                            font-size:0.12rem;
                        }
                    }                    
                    }
                    .DataImg{
                        height: 0.78rem;
                        width: 1.08rem;
                        margin-top: 0.11rem;
                        // border-radius:50%;
                        img{
                            width: 1rem;
                        }
                    }
                }
                // .BoxData:nth-child(1){
                //     padding-right: 0.16rem;
                //     border-right: 1px solid #f3f3f3;
        
                // }
                .BoxData:nth-child(3){
                    border-right:none;
                    .DataImg{
                        margin-top: 0.2rem;
                    }
                }             
                }                
            }
            #progress-bar{
                margin-top: 0.24rem;
                height: 6.8rem;
            }
            .dataSortBox{
                position: relative;
                // height: 2.9rem;
                height: 580px;
                margin-top: 0.24rem;
                .top-Name{
                    display: flex;
                    padding-top: 0.24rem;
                    padding-left: 0.32rem;
                    height: 0.3rem;   
                    align-items: center;  
                    .titleName{
                        // font-weight: 600;
                    }                             
                    i{
                        display: inline-block;
                        height: 0.15rem;
                        width: 0.15rem;
                        // background-color: red;
                        color: #5bd1b5;
                        font-size: 0.17rem;
                        font-style: normal;
                        margin-right: 0.1rem;
                    }
                    p{
                        font-size: 0.18rem;
                    }
                } 
                #dataSort{
                    .bottom-Data{
                        .table-Box{
                            margin-left: 0.32rem;
                            margin-bottom: 0.33rem;
                            margin-top: 0.2rem;
                            font-size: 0.14rem;
                            width: 93%;
                            .herader-Box{
                                font-size: 0.14rem;
                                color: #999999;
                            }
                        }
                        .dataBox{
                            width: 4.6rem !important;
                            text-overflow: ellipsis !important;
                            white-space: nowrap !important;
                            overflow: hidden !important;
                        }
                    }                   
                }
                .nodata_box{
                    position: absolute;
                    top: 0;
                    left: 47%;
                    height: 342px;
                    display: flex;
                    flex-direction: column;;
                    justify-content: center;
                    align-items: center;
                span{
                    font-size: 16px;
                    color: #ccc;
                    line-height: 44px;
                }
                }  
            }
        }
        .right-DataBox{
            width: calc(40% - 0.12rem);
            .pieOneBox{
                position: relative;
                height: 2.8rem;
                width: 100%;
                #echartsBox{
                height: 100%;
                width: 100%;
                background-color: #fff;
                -webkit-box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
                box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
                border-radius: 0.1rem;
                }
            .nodata_box{
                position: absolute;
                top: 0.26rem;
                left: 47%;
                height: 342px;
                display: flex;
                flex-direction: column;;
                justify-content: center;
                align-items: center;
            span{
                font-size: 16px;
                color: #ccc;
                line-height: 44px;
            }
            }  
            }
            .pieTwoBox{
                position: relative;
                height: 2.8rem;
                width: 100%;  
                margin-top: 0.24rem; 
                #echarts-Box{
                height: 100%;
                width: 100%;
                background-color: #fff;
                -webkit-box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
                box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
                border-radius: 0.1rem;
                }
            .nodata_box{
                position: absolute;
                top: 0.26rem;
                left: 47%;
                height: 342px;
                display: flex;
                flex-direction: column;;
                justify-content: center;
                align-items: center;
            span{
                font-size: 16px;
                color: #ccc;
                line-height: 44px;
            }
            }  
            }
            #echarts{
                position: relative;
                height: 2.8rem;
                margin-top: 0.24rem;
                width: 100%;
                background-color: #fff;
                -webkit-box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
                box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
                border-radius: 0.1rem;
            } 

        }
    }
    .bottom-DataBox{
        display: flex;
        justify-content: space-between;
        margin-top: 0.24rem;
        
        .dataSortBox{
            width: calc(60% - 0.12rem);
            background-color: #fff;
            -webkit-box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
            box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
            border-radius: 0.1rem; 
            position: relative;
            // height: 2.9rem;
            height: 580px;
                .top-Name{
                    display: flex;
                    padding-top: 0.24rem;
                    padding-left: 0.32rem;
                    height: 0.3rem;   
                    align-items: center;  
                    .titleName{
                        // font-weight: 600;
                    }                             
                    i{
                        display: inline-block;
                        height: 0.15rem;
                        width: 0.15rem;
                        // background-color: red;
                        color: #5bd1b5;
                        font-size: 0.17rem;
                        font-style: normal;
                        margin-right: 0.1rem;
                    }
                    p{
                        font-size: 0.18rem;
                    }
                } 
                #dataSort{
                    .bottom-Data{
                        .table-Box{
                            margin-left: 0.32rem;
                            margin-bottom: 0.33rem;
                            margin-top: 0.2rem;
                            margin-right: 0.32rem;
                            font-size: 0.14rem;
                            width: 93%;
                            .herader-Box{
                                font-size: 0.14rem;
                                color: #999999;
                            }
                        }
                        .dataBox{
                            cursor: pointer;
                            width: 4.6rem !important;
                            text-overflow: ellipsis !important;
                            white-space: nowrap !important;
                            overflow: hidden !important;
                        .showTips {
                            display: inline-block;
                            position: absolute;
                            left: 0;
                            top: 10;
                            padding: 6px 12px;
                            background: rgba(0, 0, 0, 0.4);
                            color: #fff;
                            border-radius: 4px;
                            }
                        }
                    }                   
                }
                .nodata_box{
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                    display: flex;
                    flex-direction: column;;
                    justify-content: center;
                    align-items: center;
                span{
                    font-size: 16px;
                    color: #ccc;
                    line-height: 44px;
                }
                }   
        }
        .S-dataSortBox{
                width: calc(40% - 0.12rem);
                position: relative;
                height: 580px;
                background-color: #fff;
                -webkit-box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
                box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
                border-radius: 0.1rem;
                .tablist{
                    width: 90%;
                    margin: 18px auto 0;
                    display: flex;
                    li{
                      padding: 5px 0;
                      width: 60px;
                      margin-right: 28px;
                      color: #999;
                      font-size: 14px;
                    }
                    li.active{
                      color: #57B9FF;
                      border-bottom: 1px solid #57B9FF;
                    }
                    li:hover{
                      cursor: pointer;
                    }
                  }
                .top-Name{
                    display: flex;
                    padding-top: 0.24rem;
                    padding-left: 0.32rem;
                    height: 0.3rem;   
                    align-items: center;    
                    .titleName{
                        // font-weight: 600;
                    }       
                    i{
                        display: inline-block;
                        height: 0.15rem;
                        width: 0.15rem;
                        color: #5bd1b5;
                        font-size: 0.17rem;
                        font-style: normal;
                        margin-right: 0.1rem;
                    }
                    p{
                        font-size: 0.18rem;
                    }
                }
                #S-dataSort{
                    width: 100%;
                    .bottom-Data{
                        padding-right: 20px;
                        .table-Box{
                            margin-left: 0.32rem;
                            margin-bottom: 0.33rem;
                            margin-top: 0.2rem;
                            font-size: 0.14rem;
                            width: 93%;
                            .herader-Box{
                                font-size: 0.14rem;
                                color: #999999;
                            }
                        }
                    }                   
                }
                .nodata_box{
                    position: absolute;
                    top:50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                    display: flex;
                    flex-direction: column;;
                    justify-content: center;
                    align-items: center;
                span{
                    font-size: 16px;
                    color: #ccc;
                    line-height: 44px;
                }
            }  
        }
    }
    .red{
        color: #ff0707
    }
    .orange{
        color: #ff771f
    }
    .yellow{
        color: #ffa72d
    }     
}
@media screen and (max-width: 768px){
    #signedDataEcharts{
        .center-DataBox{
            display: flex;
            margin-top: 0.14rem;
            flex-direction: column; 
            .left-DataBox{
                width: 100%;
                box-sizing: border-box;
                padding: 0 0.12rem;
                #lOne-box{
                    width: 100%;
                    height: 3.8rem;
                    display: flex;
                    padding: 0.2rem;
                    box-sizing: border-box;
                    flex-direction: column; 
                    .BoxText{
                        padding-top: 0;
                        padding-left: 0;
                    }
                    .regionData{
                        display: flex;
                        flex-direction: column;
                        width: 100%;
                        .BoxData{
                            width: 100%;
                            margin-left: 0;
                            padding-right: 0;
                            border-right: none;
                            height: 1.1rem;
                            border-bottom: 1px solid #f3f3f3;
                            &:last-child{
                                border-bottom: none;
                            }
                            .SmBoxData{
                                .region{
                                    font-size: 0.14rem;
                                    color:#666666;
                                    margin-top: 0.2rem;
                                } 
                                    .regionB{
                        font-size: 0.1rem;
                        color:#666666;
                        margin-top: 0.05rem;
                        i{
                            font-style: normal;
                        }
                    } 
                            }
                        }
                    }
                }
                #progress-bar{
                    width: 100%;
                    margin-top: 0.14rem;
                    background-color: #fff !important;
                }
            }
            .right-DataBox{
                width: 100%;
                padding: 0 0.12rem;
                box-sizing: border-box;
                margin-top: 0.14rem;
                .pieOneBox{
                    #echartsBox{
                        background-color: #fff !important;
                    }
                    .nodata_box{
                        left: 41%;
                        top:0.01rem;
                    }  
                }
                .pieTwoBox{
                    margin-top: 0.14rem;
                    #echarts-Box{
                        background-color: #fff !important;
                    }
                    .nodata_box{
                        left: 41%;
                        top:0.01rem;
                    } 
                }
                #echarts{
                    width: 100%;
                    margin-top: 0.14rem;
                    background-color: #fff !important;
                }
            }

        }
        .bottom-DataBox{
            margin-top: 0.14rem;
            flex-direction: column;
            padding:0 0.12rem;
            .dataSortBox{
                width: 100%;
                padding: 0 0.1rem;
                box-sizing: border-box;
                height: auto;
                min-height: 3rem;
                .top-Name{
                    margin-top: 0.14rem;
                    margin-left: 0.03rem;
                    padding-top: 0;
                    padding-left:0;
                }
                #dataSort{
                    width: 100%;
                    height: 80%;
                    .bottom-Data{
                        .table-Box{
                            margin-left: 0;
                            margin-bottom: 0;
                            margin-top: 0;
                            margin-right: 0;
                            width: 93%;
                        }
                    .dataBox{
                        width: 2rem !important;
                        text-overflow: ellipsis !important;
                        white-space: nowrap !important;
                        overflow: hidden !important;
                        .showTips{
                            width:100px;
                            white-space: normal !important;
                        }
                    }
                    }
                }
                .nodata_box{
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                    display: flex;
                    flex-direction: column;;
                    justify-content: center;
                    align-items: center;
                span{
                    font-size: 16px;
                    color: #ccc;
                    line-height: 44px;
                }
                }
            }
            .S-dataSortBox{
                margin-top:0.14rem;
                width: 100%;
                padding: 0 0.1rem;
                height: auto;
                min-height: 3rem;
                box-sizing: border-box;
                .top-Name{
                    margin-top: 0.14rem;
                    margin-left: 0.03rem;
                    padding-top: 0;
                    padding-left:0;
                }
                #S-dataSort{
                    width: 100%;
                    height: 80%;
                    .bottom-Data{
                        .table-Box{
                            margin-left: 0;
                            margin-bottom: 0;
                            margin-top: 0;
                            width: 93%;
                        }
                    .dataBox{
                        width: 2rem !important;
                        text-overflow: ellipsis !important;
                        white-space: nowrap !important;
                        overflow: hidden !important;
                    }
                    }
                }
                .nodata_box{
                    position: absolute;
                    top: 60%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                    display: flex;
                    flex-direction: column;;
                    justify-content: center;
                    align-items: center;
                span{
                    font-size: 16px;
                    color: #ccc;
                    line-height: 44px;
                }
                }
            }
        }
        .show{
            display: none;
        }
    }
}
@media screen and (max-width: 1366px){
    #signedDataEcharts{
        .center-DataBox{
            .left-DataBox{
                #lOne-box{
                    .regionData{
                        .BoxData{
                            .SmBoxData{
                            .number{
                                font-size: 0.18rem;
                            }
                            .region{
                                font-size: 0.14rem;
                            }
                            .regionB{
                                font-size: 0.14rem;
                            }
                            }

                            .DataImg{
                                height: 0.6rem;
                                width: 0.6rem;
                                margin-top: 0.4rem;
                                img{
                                    width: 100%;
                                }
                            }
                            &:nth-child(3){
                            .DataImg{
                                height: 0.6rem;
                                width: 0.6rem;
                                margin-top: 0.4rem;
                                img{
                                    width: 100%;
                                }
                            }
                            }
                        }
                    }
                }
            }
        }
        .bottom-DataBox{
            .dataSortBox{
                 #dataSort{
                     .bottom-Data{
                        .dataBox{
                            width: 4rem !important;
                        }
                    }
                 }
            }
        }
    }

}
@media screen and (max-width: 1536px){
    #signedDataEcharts .center-DataBox .left-DataBox #lOne-box .regionData .BoxData .SmBoxData .number{
    font-size: 0.14rem;
    margin-top: 0.1rem;
}
#signedDataEcharts .center-DataBox .left-DataBox #lOne-box .regionData .BoxData .DataImg{
    height: 0.58rem;
    width: 0.8rem;
    margin-top: 0.11rem;
}
#signedDataEcharts .center-DataBox .left-DataBox #lOne-box .regionData .BoxData .DataImg img{
    height: 0.58rem;
    width: 0.9rem;
}
}
</style>


// WEBPACK FOOTER //
// signedDataEcharts.vue?75b80153